import { useState, useRef, useCallback, useEffect } from 'react';
export const useDraggableDialog = ({ screenPosition: _screenPosition, // intentionally unused — modal always anchors top-right
dialogWidth, sidebarWidth: _sidebarWidth = 0 }) => {
    const padding = 16;
    const rightInset = 120; // wider gap from the right edge so the modal isn't squashed against it
    // Always open at top-right of the viewport. User can drag elsewhere afterward;
    // each open resets to top-right so behaviour is predictable.
    const [position, setPosition] = useState(() => {
        const left = Math.max(padding, window.innerWidth - dialogWidth - rightInset);
        const top = padding;
        return { x: left, y: top };
    });
    const [isDragging, setIsDragging] = useState(false);
    const dragStartRef = useRef({ x: 0, y: 0 });
    const handleMouseDown = useCallback((e) => {
        if (e.target.closest('.drag-handle')) {
            setIsDragging(true);
            dragStartRef.current = { x: e.clientX - position.x, y: e.clientY - position.y };
            e.preventDefault();
        }
    }, [position]);
    useEffect(() => {
        if (!isDragging)
            return;
        const handleMouseMove = (e) => {
            const newX = Math.max(0, Math.min(window.innerWidth - dialogWidth, e.clientX - dragStartRef.current.x));
            const newY = Math.max(0, Math.min(window.innerHeight - 100, e.clientY - dragStartRef.current.y));
            setPosition({ x: newX, y: newY });
        };
        const handleMouseUp = () => {
            setIsDragging(false);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, dialogWidth]);
    return { position, setPosition, isDragging, handleMouseDown };
};
